import { LegalDocument } from '@/legal/components/LegalDocument';
import content from '@/legal/content/cookie-ru-v1.0.md?raw';

export function CookiePolicyPage() {
  return (
    <LegalDocument
      title="Политика использования файлов cookie"
      content={content}
      version="1.0"
      effectiveDate="2026-05-07"
      readingMinutes={7}
      jurisdictions={['ru', 'eu', 'us']}
    />
  );
}
